//Encore positions
import p8227 from '../assets/data/EncoreVoyages/8227/positions.json';
import p8226 from '../assets/data/EncoreVoyages/8226/positions.json';
import p8225 from '../assets/data/EncoreVoyages/8225/positions.json';
import p8224 from '../assets/data/EncoreVoyages/8224/positions.json';
import p8223 from '../assets/data/EncoreVoyages/8223/positions.json';
import p8222 from '../assets/data/EncoreVoyages/8222/positions.json';
import p8221 from '../assets/data/EncoreVoyages/8221/positions.json';
import p8220 from '../assets/data/EncoreVoyages/8220/positions.json';
import p8214 from '../assets/data/EncoreVoyages/8214/positions.json';
import p6943 from '../assets/data/EncoreVoyages/6943/positions.json';
import p6944 from '../assets/data/EncoreVoyages/6944/positions.json';
import p6520 from '../assets/data/EncoreVoyages/6520/positions.json';
import p6519 from '../assets/data/EncoreVoyages/6519/positions.json';
import p6518 from '../assets/data/EncoreVoyages/6518/positions.json';
import p6517 from '../assets/data/EncoreVoyages/6517/positions.json';
import p6516 from '../assets/data/EncoreVoyages/6516/positions.json';
import p6515 from '../assets/data/EncoreVoyages/6515/positions.json';
import p6514 from '../assets/data/EncoreVoyages/6514/positions.json';
import p5430 from '../assets/data/EncoreVoyages/5430/positions.json';
import p5212 from '../assets/data/EncoreVoyages/5212/positions.json';
import p5153 from '../assets/data/EncoreVoyages/5153/positions.json';
import p5101 from '../assets/data/EncoreVoyages/5101/positions.json';
import p5102 from '../assets/data/EncoreVoyages/5102/positions.json';

//Encore entries
import e8227 from '../assets/data/EncoreVoyages/8227/entries.json';
import e8226 from '../assets/data/EncoreVoyages/8226/entries.json';
import e8225 from '../assets/data/EncoreVoyages/8225/entries.json';
import e8224 from '../assets/data/EncoreVoyages/8224/entries.json';
import e8223 from '../assets/data/EncoreVoyages/8223/entries.json';
import e8222 from '../assets/data/EncoreVoyages/8222/entries.json';
import e8221 from '../assets/data/EncoreVoyages/8221/entries.json';
import e8220 from '../assets/data/EncoreVoyages/8220/entries.json';
import e8214 from '../assets/data/EncoreVoyages/8214/entries.json';
import e6943 from '../assets/data/EncoreVoyages/6943/entries.json';
import e6944 from '../assets/data/EncoreVoyages/6944/entries.json';
import e6520 from '../assets/data/EncoreVoyages/6520/entries.json';
import e6519 from '../assets/data/EncoreVoyages/6519/entries.json';
import e6518 from '../assets/data/EncoreVoyages/6518/entries.json';
import e6517 from '../assets/data/EncoreVoyages/6517/entries.json';
import e6516 from '../assets/data/EncoreVoyages/6516/entries.json';
import e6515 from '../assets/data/EncoreVoyages/6515/entries.json';
import e6514 from '../assets/data/EncoreVoyages/6514/entries.json';
import e5430 from '../assets/data/EncoreVoyages/5430/entries.json';
import e5212 from '../assets/data/EncoreVoyages/5212/entries.json';
import e5153 from '../assets/data/EncoreVoyages/5153/entries.json';
import e5101 from '../assets/data/EncoreVoyages/5101/entries.json';
import e5102 from '../assets/data/EncoreVoyages/5102/entries.json';

//Ovation positions
import p8948 from '../assets/data/OvationVoyages/8948/positions.json';
import p8801 from '../assets/data/OvationVoyages/8801/positions.json';
import p7803 from '../assets/data/OvationVoyages/7803/positions.json';
import p7592 from '../assets/data/OvationVoyages/7592/positions.json';

//Ovation entries
import e8948 from '../assets/data/OvationVoyages/8948/entries.json';
import e8801 from '../assets/data/OvationVoyages/8801/entries.json';
import e7803 from '../assets/data/OvationVoyages/7803/entries.json';
import e7592 from '../assets/data/OvationVoyages/7592/entries.json';

//Quest positions
import p9166 from '../assets/data/QuestVoyages/9166/positions.json';
import p8976 from '../assets/data/QuestVoyages/8976/positions.json';
import p8928 from '../assets/data/QuestVoyages/8928/positions.json';
import p8875 from '../assets/data/QuestVoyages/8875/positions.json';
import p8772 from '../assets/data/QuestVoyages/8772/positions.json';
import p8707 from '../assets/data/QuestVoyages/8707/positions.json';
import p8496 from '../assets/data/QuestVoyages/8496/positions.json';
import p8410 from '../assets/data/QuestVoyages/8410/positions.json';
import p8368 from '../assets/data/QuestVoyages/8368/positions.json';
import p8336 from '../assets/data/QuestVoyages/8336/positions.json';
import p8269 from '../assets/data/QuestVoyages/8269/positions.json';
import p8216 from '../assets/data/QuestVoyages/8216/positions.json';
import p8121 from '../assets/data/QuestVoyages/8121/positions.json';
import p8037 from '../assets/data/QuestVoyages/8037/positions.json';
import p7711 from '../assets/data/QuestVoyages/7711/positions.json';
import p7636 from '../assets/data/QuestVoyages/7636/positions.json';
import p7533 from '../assets/data/QuestVoyages/7533/positions.json';
import p7467 from '../assets/data/QuestVoyages/7467/positions.json';
import p7359 from '../assets/data/QuestVoyages/7359/positions.json';
import p7251 from '../assets/data/QuestVoyages/7251/positions.json';
import p6955 from '../assets/data/QuestVoyages/6955/positions.json';
import p6828 from '../assets/data/QuestVoyages/6828/positions.json';
import p6762 from '../assets/data/QuestVoyages/6762/positions.json';
import p6703 from '../assets/data/QuestVoyages/6703/positions.json';
import p6631 from '../assets/data/QuestVoyages/6631/positions.json';
import p6211 from '../assets/data/QuestVoyages/6211/positions.json';
import p6132 from '../assets/data/QuestVoyages/6132/positions.json';
import p6070 from '../assets/data/QuestVoyages/6070/positions.json';
import p5929 from '../assets/data/QuestVoyages/5929/positions.json';
import p5790 from '../assets/data/QuestVoyages/5790/positions.json';
import p5467 from '../assets/data/QuestVoyages/5467/positions.json';
import p5216 from '../assets/data/QuestVoyages/5216/positions.json';
import p5157 from '../assets/data/QuestVoyages/5157/positions.json';
import p5086 from '../assets/data/QuestVoyages/5086/positions.json';
import p5024 from '../assets/data/QuestVoyages/5024/positions.json';
import p4938 from '../assets/data/QuestVoyages/4938/positions.json';
import p4453 from '../assets/data/QuestVoyages/4453/positions.json';
import p4405 from '../assets/data/QuestVoyages/4405/positions.json';
import p4350 from '../assets/data/QuestVoyages/4350/positions.json';
import p4247 from '../assets/data/QuestVoyages/4247/positions.json';
import p4095 from '../assets/data/QuestVoyages/4095/positions.json';
import p3724 from '../assets/data/QuestVoyages/3724/positions.json';
import p3617 from '../assets/data/QuestVoyages/3617/positions.json';
import p3483 from '../assets/data/QuestVoyages/3483/positions.json';
import p3372 from '../assets/data/QuestVoyages/3372/positions.json';
import p3272 from '../assets/data/QuestVoyages/3272/positions.json';
import p2945 from '../assets/data/QuestVoyages/2945/positions.json';
import p2856 from '../assets/data/QuestVoyages/2856/positions.json';
import p2914 from '../assets/data/QuestVoyages/2914/positions.json';
import p2259 from '../assets/data/QuestVoyages/2259/positions.json';
import p2167 from '../assets/data/QuestVoyages/2167/positions.json';
import p2111 from '../assets/data/QuestVoyages/2111/positions.json';
import p2074 from '../assets/data/QuestVoyages/2074/positions.json';

//Quest entries
import e9166 from '../assets/data/QuestVoyages/9166/entries.json';
import e8976 from '../assets/data/QuestVoyages/8976/entries.json';
import e8928 from '../assets/data/QuestVoyages/8928/entries.json';
import e8875 from '../assets/data/QuestVoyages/8875/entries.json';
import e8772 from '../assets/data/QuestVoyages/8772/entries.json';
import e8707 from '../assets/data/QuestVoyages/8707/entries.json';
import e8496 from '../assets/data/QuestVoyages/8496/entries.json';
import e8410 from '../assets/data/QuestVoyages/8410/entries.json';
import e8368 from '../assets/data/QuestVoyages/8368/entries.json';
import e8336 from '../assets/data/QuestVoyages/8336/entries.json';
import e8269 from '../assets/data/QuestVoyages/8269/entries.json';
import e8216 from '../assets/data/QuestVoyages/8216/entries.json';
import e8121 from '../assets/data/QuestVoyages/8121/entries.json';
import e8037 from '../assets/data/QuestVoyages/8037/entries.json';
import e7711 from '../assets/data/QuestVoyages/7711/entries.json';
import e7636 from '../assets/data/QuestVoyages/7636/entries.json';
import e7533 from '../assets/data/QuestVoyages/7533/entries.json';
import e7467 from '../assets/data/QuestVoyages/7467/entries.json';
import e7359 from '../assets/data/QuestVoyages/7359/entries.json';
import e7251 from '../assets/data/QuestVoyages/7251/entries.json';
import e6955 from '../assets/data/QuestVoyages/6955/entries.json';
import e6828 from '../assets/data/QuestVoyages/6828/entries.json';
import e6762 from '../assets/data/QuestVoyages/6762/entries.json';
import e6703 from '../assets/data/QuestVoyages/6703/entries.json';
import e6631 from '../assets/data/QuestVoyages/6631/entries.json';
import e6211 from '../assets/data/QuestVoyages/6211/entries.json';
import e6132 from '../assets/data/QuestVoyages/6132/entries.json';
import e6070 from '../assets/data/QuestVoyages/6070/entries.json';
import e5929 from '../assets/data/QuestVoyages/5929/entries.json';
import e5790 from '../assets/data/QuestVoyages/5790/entries.json';
import e5467 from '../assets/data/QuestVoyages/5467/entries.json';
import e5216 from '../assets/data/QuestVoyages/5216/entries.json';
import e5157 from '../assets/data/QuestVoyages/5157/entries.json';
import e5086 from '../assets/data/QuestVoyages/5086/entries.json';
import e5024 from '../assets/data/QuestVoyages/5024/entries.json';
import e4938 from '../assets/data/QuestVoyages/4938/entries.json';
import e4453 from '../assets/data/QuestVoyages/4453/entries.json';
import e4405 from '../assets/data/QuestVoyages/4405/entries.json';
import e4350 from '../assets/data/QuestVoyages/4350/entries.json';
import e4247 from '../assets/data/QuestVoyages/4247/entries.json';
import e4095 from '../assets/data/QuestVoyages/4095/entries.json';
import e3724 from '../assets/data/QuestVoyages/3724/entries.json';
import e3617 from '../assets/data/QuestVoyages/3617/entries.json';
import e3483 from '../assets/data/QuestVoyages/3483/entries.json';
import e3372 from '../assets/data/QuestVoyages/3372/entries.json';
import e3272 from '../assets/data/QuestVoyages/3272/entries.json';
import e2945 from '../assets/data/QuestVoyages/2945/entries.json';
import e2856 from '../assets/data/QuestVoyages/2856/entries.json';
import e2914 from '../assets/data/QuestVoyages/2914/entries.json';
import e2259 from '../assets/data/QuestVoyages/2259/entries.json';
import e2167 from '../assets/data/QuestVoyages/2167/entries.json';
import e2111 from '../assets/data/QuestVoyages/2111/entries.json';
import e2074 from '../assets/data/QuestVoyages/2074/entries.json';

//Sojourn positions
import p7371 from '../assets/data/SojournVoyages/7371/positions.json';
import p7369 from '../assets/data/SojournVoyages/7369/positions.json';
import p7367 from '../assets/data/SojournVoyages/7367/positions.json';
import p6314 from '../assets/data/SojournVoyages/6314/positions.json';
import p6268 from '../assets/data/SojournVoyages/6268/positions.json';
import p6189 from '../assets/data/SojournVoyages/6189/positions.json';
import p6061 from '../assets/data/SojournVoyages/6061/positions.json';
import p5942 from '../assets/data/SojournVoyages/5942/positions.json';
import p5826 from '../assets/data/SojournVoyages/5826/positions.json';


//Sojourn entries
import e7371 from '../assets/data/SojournVoyages/7371/entries.json';
import e7369 from '../assets/data/SojournVoyages/7369/entries.json';
import e7367 from '../assets/data/SojournVoyages/7367/entries.json';
import e6314 from '../assets/data/SojournVoyages/6314/entries.json';
import e6268 from '../assets/data/SojournVoyages/6268/entries.json';
import e6189 from '../assets/data/SojournVoyages/6189/entries.json';
import e6061 from '../assets/data/SojournVoyages/6061/entries.json';
import e5942 from '../assets/data/SojournVoyages/5942/entries.json';
import e5826 from '../assets/data/SojournVoyages/5826/entries.json';

import encoreVoyages from '../assets/data/EncoreVoyages.json';
import ovationVoyages from '../assets/data/OvationVoyages.json';
import questVoyages from '../assets/data/QuestVoyages.json';
import sojournVoyages from '../assets/data/SojournVoyages.json';


export const voyagesPositions: any = {
  8227: p8227,
  8226: p8226,
  8225: p8225,
  8224: p8224,
  8223: p8223,
  8222: p8222,
  8221: p8221,
  8220: p8220,
  8214: p8214,
  6943: p6943,
  6944: p6944,
  6520: p6520,
  6519: p6519,
  6518: p6518,
  6517: p6517,
  6516: p6516,
  6515: p6515,
  6514: p6514,
  5430: p5430,
  5212: p5212,
  5153: p5153,
  5101: p5101,
  5102: p5102,
  7371: p7371,
  7369: p7369,
  7367: p7367,
  6314: p6314,
  6268: p6268,
  6189: p6189,
  6061: p6061,
  5942: p5942,
  5826: p5826,
  8948: p8948,
  8801: p8801,
  7803: p7803,
  7592: p7592,
  9166: p9166,
  8976: p8976,
  8928: p8928,
  8875: p8875,
  8772: p8772,
  8707: p8707,
  8496: p8496,
  8410: p8410,
  8368: p8368,
  8336: p8336,
  8269: p8269,
  8216: p8216,
  8121: p8121,
  8037: p8037,
  7711: p7711,
  7636: p7636,
  7533: p7533,
  7467: p7467,
  7359: p7359,
  7251: p7251,
  6955: p6955,
  6828: p6828,
  6762: p6762,
  6703: p6703,
  6631: p6631,
  6211: p6211,
  6132: p6132,
  6070: p6070,
  5929: p5929,
  5790: p5790,
  5467: p5467,
  5216: p5216,
  5157: p5157,
  5086: p5086,
  5024: p5024,
  4938: p4938,
  4453: p4453,
  4405: p4405,
  4350: p4350,
  4247: p4247,
  4095: p4095,
  3724: p3724,
  3617: p3617,
  3483: p3483,
  3372: p3372,
  3272: p3272,
  2945: p2945,
  2856: p2856,
  2914: p2914,
  2259: p2259,
  2167: p2167,
  2111: p2111,
  2074: p2074,
};

export const voyagesEntries: any = {
  8227: e8227,
  8226: e8226,
  8225: e8225,
  8224: e8224,
  8223: e8223,
  8222: e8222,
  8221: e8221,
  8220: e8220,
  8214: e8214,
  6943: e6943,
  6944: e6944,
  6520: e6520,
  6519: e6519,
  6518: e6518,
  6517: e6517,
  6516: e6516,
  6515: e6515,
  6514: e6514,
  5430: e5430,
  5212: e5212,
  5153: e5153,
  5101: e5101,
  5102: e5102,
  7371: e7371,
  7369: e7369,
  7367: e7367,
  6314: e6314,
  6268: e6268,
  6189: e6189,
  6061: e6061,
  5942: e5942,
  5826: e5826,
  8948: e8948,
  8801: e8801,
  7803: e7803,
  7592: e7592,
  9166: e9166,
  8976: e8976,
  8928: e8928,
  8875: e8875,
  8772: e8772,
  8707: e8707,
  8496: e8496,
  8410: e8410,
  8368: e8368,
  8336: e8336,
  8269: e8269,
  8216: e8216,
  8121: e8121,
  8037: e8037,
  7711: e7711,
  7636: e7636,
  7533: e7533,
  7467: e7467,
  7359: e7359,
  7251: e7251,
  6955: e6955,
  6828: e6828,
  6762: e6762,
  6703: e6703,
  6631: e6631,
  6211: e6211,
  6132: e6132,
  6070: e6070,
  5929: e5929,
  5790: e5790,
  5467: e5467,
  5216: e5216,
  5157: e5157,
  5086: e5086,
  5024: e5024,
  4938: e4938,
  4453: e4453,
  4405: e4405,
  4350: e4350,
  4247: e4247,
  4095: e4095,
  3724: e3724,
  3617: e3617,
  3483: e3483,
  3372: e3372,
  3272: e3272,
  2945: e2945,
  2856: e2856,
  2914: e2914,
  2259: e2259,
  2167: e2167,
  2111: e2111,
  2074: e2074,
};

export const ships: any = {
  Encore: encoreVoyages,
  Ovation: ovationVoyages,
  Quest: questVoyages,
  Sojourn: sojournVoyages,
  
};

